export default "__VITE_ASSET__vKc__vMx__"